module.exports = __webpack_public_path__ + "static/media/gaming1.0783066c.webp";